import React, {useEffect, useState} from 'react';
import CustomInput from "../../../components/UI/customInput/customInput";
import {Link} from "react-router-dom";
import {Get, Post} from "../../../apis/api";
import {toast} from "react-toastify";
import CustomButton from "../../../components/UI/customButton/customButton";
import CustomSelect from "../../../components/UI/customSelect/customSelect";
import {useSelector} from "react-redux";
import { useTranslation } from 'react-i18next';

const AccountSection = ({data , onCreate , agentData , setStep}) => {
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({})
  const user = useSelector((state) => state.user.user)


  const handleForm = ({name, value}) => {
    setForm((prevState) => ({...prevState, [name]: value}))
  }
  const handleSubmit = () => {
    setLoading(true);
    Post(`${data?.id ? `${user?.role_key === "super_admin" ? "admin" : "agent"}/crews/${data.id}/update` : `${user?.role_key === "super_admin" ? "admin" : "agent"}/crews/store`}`, { ...form , "form" :  `${user?.role_key === "super_admin" ? "admin" : "agent"}_store_form` })
      .then((res) => {
        toast.success(res.msg)
        onCreate(res.details.data.id)
        setStep(2)
      })
      .catch((error) => {
        toast.error(error.data.message || error.data.msg)
      })
      .finally(() => {
        setLoading(false);
      });
  }



  useEffect(() => {
    setForm(data)
  } ,[data])

  const handleAgent = (id) => {
    return agentData?.find((item => {
      return (
        item.id === id
      )
    }))
  }


  return (
    <div className={"mt-8"}>
      <div className={"my-container rounded-lg flex flex-col gap-5 w-full bg-white p-5 px-5 md:px-[15%]"}>
       <span className={"text-gray-500"}>
         {/* {"To create a new crew member, please complete the information below."} */}
       </span>
        <div className={"flex flex-col gap-5"}>
          <span className={"w-full"}>
             <CustomInput
               placeHolder={"Crew Name"}
               label={"Crew Name"}
               name={"name"}
               onchange={handleForm}
               defaultValue={form.name}
             />
          </span>
          <span className={"w-full"}>
             <CustomInput
               placeHolder={"Crew Last Name"}
               label={"Crew Last Name"}
               name={"last_name"}
               defaultValue={form.last_name}
               onchange={handleForm}
             />
          </span>
          <span className={"w-full"}>
             <CustomInput
               placeHolder={"Crew Email"}
               label={"Crew Email"}
               name={"email"}
               defaultValue={form.email}
               onchange={handleForm}
             />
          </span>
          {/* <span className={"w-full"}>
             <CustomSelect
               agent={true}
               name="agent_id"
               label={"Agent Name"}
               options={agentData}
               defaultValue={handleAgent(form["agent_id"])}
               onchange={(e) => handleForm(e)}
             />
          </span> */}
          <span className={"w-full"}>
             <CustomInput
               placeHolder={"password"}
               label={"password"}
               name={"password"}
               onchange={handleForm}
             />
          </span>
        </div>
      </div>
      <div className={"my-container pt-5"}>
        <div className={"w-full flex justify-between items-center"}>
          <Link to={"/crew"} className={"text-main"}>
            {"close"}
          </Link>
          <div className={"w-[220px]"}>
            <CustomButton loading={loading} onClick={handleSubmit}  title={"Save Information"}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSection;
